import {Column, Row, Text} from "react-vcomponents";
import {BaseComponent} from "react-vextensions";
import {Observer} from "web-vcore";
import moment from "moment";
import React, {useState} from "react";
import {JournalEntry, JournalSegment} from "../../../Server/DB/journalEntries/@JournalEntry.js";
import {store} from "../../../Store/index.js";
import {DreamEventsUI} from "./DreamEventsUI.js";
import {SegmentActionButton} from "./SegmentUI/SegmentActionButton.js";
import {GetDreamEvents} from "../../../Server/DB/journalEntries.js";
import {observer_mgl, RunInAction} from "mobx-graphlink";
import {JournalSegmentUI} from "./SegmentUI.js";
import {SegmentScenesUI} from "./SegmentUI/SegmentScenesUI.js";

export function IsSegmentASleepCycleStarter(segment: JournalSegment, prevSegment: JournalSegment|n) {
	// first segment always start's the first sleep-cycle
	if (prevSegment == null) return true;
	// sleep-cycles also start for wake-segments preceded by a non-wake segment
	if (segment.wakeTime != null && prevSegment.wakeTime == null) return true;
	return false;
}

//const SegmentUI_columns = 9;
export const SegmentHeader_Wake = observer_mgl(({entry, segment, segmentIndex, onToggleExpanded}: {entry: JournalEntry, segment: JournalSegment, segmentIndex: number, onToggleExpanded?: (()=>any)|n})=>{
	const uiState = store.main.engine.journey;
	const priorSegments = entry.segments.slice(0, segmentIndex);
	const isSleepCycleStarter = IsSegmentASleepCycleStarter(segment, priorSegments.LastOrX());

	let sleepCycleNumberStr = "";
	if (isSleepCycleStarter) {
		const priorSleepCycleStarters = priorSegments.filter((segment, i)=>{
			return IsSegmentASleepCycleStarter(segment, priorSegments[i - 1]);
		}).length;
		sleepCycleNumberStr = `#${priorSleepCycleStarters + 1} `;
	}

	//const [detailsOpen, setDetailsOpen] = useState(false);
	const segmentKey = `${entry.id}_${segmentIndex}`;

	return (
		<Column mt={5} /*pl={10}*/ style={{position: "relative", background: "rgba(255,255,255,.2)"}}>
			{/*<div style={{position: "absolute", left: 0, top: 0, bottom: 0, width: 10, background: "white"}}/>*/}
			<Row>
				<SegmentActionButton parentDroppableInfo={null} journalEntry={entry} segment={segment} onClick={()=>{
					//setDetailsOpen(!detailsOpen);
					uiState.ToggleSegmentExpanded(segmentKey);
					onToggleExpanded?.();
				}}/>
				<Text ml={5}>{sleepCycleNumberStr}Awoke at: {moment(segment.wakeTime!).format("HH:mm:ss")}</Text>
			</Row>
			{uiState.expandedSegments.has(segmentKey) &&
			<JournalSegmentUI entry={entry} segment={segment} segments={entry.segments} showActionsRow={true}/>}
		</Column>
	);
});

export const SegmentHeader_Dream = observer_mgl(({entry, segment, segmentIndex, journalPage, onToggleExpanded}: {
	entry: JournalEntry, segment: JournalSegment, segmentIndex: number,
	journalPage: boolean, onToggleExpanded?: (()=>any)|n,
})=>{
	const uiState1 = store.main.journal;
	const uiState2 = store.main.engine.journey;
	const dreamEvents = GetDreamEvents(segment);

	const longTextLengthLimit_chars = uiState1.longTextLengthLimit_enabled ? uiState1.longTextLengthLimit_chars : Infinity;
	const longText_trimmed = segment.longText.length > longTextLengthLimit_chars ? segment.longText.slice(0, longTextLengthLimit_chars) : segment.longText;
	const longText_trimmedChars = segment.longText.length - longText_trimmed.length;

	//const [detailsOpen, setDetailsOpen] = useState(false);
	const segmentKey = `${entry.id}_${segmentIndex}`;

	return (
		<Column mt={5} /*pl={10}*/ style={{position: "relative", background: "rgba(0,0,255,.3)"}}>
			{/*<div style={{position: "absolute", left: 0, top: 0, bottom: 0, width: 10, background: "rgba(0,0,255,1)"}}/>*/}
			<Column style={{flex: 1}}>
				<Row style={{alignItems: "flex-start"}}>
					<SegmentActionButton parentDroppableInfo={null} // todo: maybe find way to add this back (if using dnd again)
						journalEntry={entry} segment={segment} onClick={()=>{
							uiState2.ToggleSegmentExpanded(segmentKey);
							onToggleExpanded?.();
						}}/>
					<Column>
						<SegmentScenesUI entry={entry} segment={segment} hideIfNoScenes={true}/>
						<DreamEventsUI segment={segment} events={dreamEvents}/>
						{journalPage &&
						<Row sel style={{
							padding: 5, whiteSpace: store.main.journal.textPreviewMultiline ? null : "nowrap",
							//background: index % 2 == 0 ? "rgba(30,30,30,.7)" : "rgba(0,0,0,.7)",
							background: "rgba(30,30,30,.7)",
						}}>
							<Text>
								{longText_trimmed}
								{longText_trimmedChars > 0 && <span style={{marginLeft: 5, display: "contents", fontWeight: "bold", color: "orange"}}>{longText_trimmed.endsWith(" ") ? "" : " "}[+{longText_trimmedChars}]</span>}
							</Text>
						</Row>}
					</Column>
					{/*!journalPage && <>
						<DreamEntitiesList entry={entry} segment={segment} segmentIndex={segmentIndex}/>
					</>*/}
				</Row>
			</Column>
			{uiState2.expandedSegments.has(segmentKey) &&
			<JournalSegmentUI entry={entry} segment={segment} segments={entry.segments} showActionsRow={true}/>}
		</Column>
	);
});